import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {API} from '@configs/api.config';
import {Jpm} from '@control-tower/models/jpm';
import {OrgUser} from 'app/modules/organization/models/org-user';
import {Observable} from 'rxjs';
import {JPMsPathSummary} from '../models/jpms-path-summary.model';
import {OrgDetails} from '../models/org-details.model';
import {LiveMapFilterRequest} from '../models/live-map-filter-request.model';
import { SharedJobsFilterRequest } from '../models/shared-jobs-request.model';
import { User } from '@core/models/user.model';


@Injectable()
export class SharedJobService {

  constructor(private readonly httpClient: HttpClient) {}

  getSharedJPMs(request: SharedJobsFilterRequest): Observable<Jpm[]> {
    const url = API.jpm.getAllAllowedJPMs;
    return this.httpClient.post<Jpm[]>(url, request);
  }

  getJPMsOngoingPaths(jpmIds: string[]): Observable<any[]> {
    const url = API.jpm.getAllAllowedJPMs;
    return this.httpClient.post<any[]>(url, jpmIds);
  }

  getCompletedPathsOfJPMs(jpmIds: string[]): Observable<JPMsPathSummary[]> {
    const url = API.fmGPS.getEncodedPathsOfJPMsByJPMIds;
    return this.httpClient.post<JPMsPathSummary[]>(url, jpmIds);
  }

  getSelectedJpmHumanResources(resourceIds: string[]): Observable<OrgUser[]> {
    const url = API.organization.getOrgPersonsByIds;
    return this.httpClient.post<OrgUser[]>(url, resourceIds);
  }

  getCollaboratorData(collaboratorIds: string[]): Observable<User[]> {
    const url = API.organization.getOrgPersonsByIds;
    return this.httpClient.post<User[]>(url, collaboratorIds);
  }

  getCustomers(orgId: string, orgUserId: string): Observable<OrgDetails[]> {
    const url = API.organization.getLiveMapCustomers.format([orgId, orgUserId]);
    return this.httpClient.get<OrgDetails[]>(url);
  }

  getServiceProviders(orgId: string, orgUserId: string): Observable<OrgDetails[]> {
    const url = API.organization.getLiveMapServiceProviders.format([orgId, orgUserId]);
    return this.httpClient.get<OrgDetails[]>(url);
  }

  filterLiveMapJobs(liveMapFilterRequest: LiveMapFilterRequest): Observable<Jpm[]> {
    const url = API.jpm.filterLiveMapJobs;
    return this.httpClient.post<Jpm[]>(url, liveMapFilterRequest);
  }
}
